import { AcademyMockApi } from 'app/core/mock-api/apps/academy/api';
import { ActivitiesMockApi } from 'app/core/mock-api/pages/activities/api';
import { AnalyticsMockApi } from 'app/core/mock-api/dashboards/analytics/api';
import { AuthMockApi } from 'app/core/mock-api/common/auth/api';
import { ChatMockApi } from 'app/core/mock-api/apps/chat/api';
import { ContactsMockApi } from 'app/core/mock-api/apps/contacts/api';
import { CryptoMockApi } from 'app/core/mock-api/dashboards/crypto/api';
import { ECommerceInventoryMockApi } from 'app/core/mock-api/apps/ecommerce/inventory/api';
import { FileManagerMockApi } from 'app/core/mock-api/apps/file-manager/api';
import { FinanceMockApi } from 'app/core/mock-api/dashboards/finance/api';
import { HelpCenterMockApi } from 'app/core/mock-api/apps/help-center/api';
import { IconsMockApi } from 'app/core/mock-api/ui/icons/api';
import { MailboxMockApi } from 'app/core/mock-api/apps/mailbox/api';
import { MessagesMockApi } from 'app/core/mock-api/common/messages/api';
import { NavigationMockApi } from 'app/core/mock-api/common/navigation/api';
import { NotesMockApi } from 'app/core/mock-api/apps/notes/api';
import { NotificationsMockApi } from 'app/core/mock-api/common/notifications/api';
import { ProjectMockApi } from 'app/core/mock-api/dashboards/project/api';
import { SearchMockApi } from 'app/core/mock-api/common/search/api';
import { ShortcutsMockApi } from 'app/core/mock-api/common/shortcuts/api';
import { TasksMockApi } from 'app/core/mock-api/apps/tasks/api';
import { UserMockApi } from 'app/core/mock-api/common/user/api';

export const mockApiServices = [
  AcademyMockApi,
  ActivitiesMockApi,
  AnalyticsMockApi,
  AuthMockApi,
  ChatMockApi,
  ContactsMockApi,
  CryptoMockApi,
  ECommerceInventoryMockApi,
  FileManagerMockApi,
  FinanceMockApi,
  HelpCenterMockApi,
  IconsMockApi,
  MailboxMockApi,
  MessagesMockApi,
  NavigationMockApi,
  NotesMockApi,
  NotificationsMockApi,
  ProjectMockApi,
  SearchMockApi,
  ShortcutsMockApi,
  TasksMockApi,
  UserMockApi
];
